module.exports = __webpack_public_path__ + "7ce4d74be4129e8aa4a1606283d695d7.svg";